import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import React from "react"
import { createBfzArticleTeaserLink } from "components/page-components/Teaser-Cards/utils"

export const AdvertorialThree = ({ advertorialThreeData }) => {
  const advertorial_link = createBfzArticleTeaserLink(advertorialThreeData)

  return (
    <Link to={advertorial_link}>
      <div className="mx-3" style={{ position: "relative" }}>
        <hr className="has-background-mitternachtsblau-30 is-slim" />

        <div
          style={{ position: "absolute", bottom: 5, right: 5 }}
          className="ad-disclaimer"
        >
          Anzeige
        </div>
        <div className="is-flex is-flex-direction-row">
          <GatsbyImage
            image={
              advertorialThreeData?.thumbnail?.childImageSharp?.gatsbyImageData
            }
            className="my-auto mr-5"
            imgStyle={{ maxWidth: 250, maxHeight: 250 }}
            style={{ maxWidth: 250, maxHeight: 250 }}
            alt={advertorialThreeData?.headline}
          />
          <div className="my-auto" style={{ minWidth: "50%" }}>
            <p className="title is-5 is-size-6-mobile has-text-mitternachtsblau my-auto">
              {advertorialThreeData?.headline}
            </p>
            <p className="has-text-mitternachtsblau help is-hidden-mobile">
              {advertorialThreeData?.teaser_short}
            </p>
          </div>
        </div>
        <hr className="has-background-mitternachtsblau-30 is-slim" />
      </div>
    </Link>
  )
}
